import { render, staticRenderFns } from "./RightItem.vue?vue&type=template&id=02684ded&scoped=true&"
import script from "./RightItem.vue?vue&type=script&lang=js&"
export * from "./RightItem.vue?vue&type=script&lang=js&"
import style0 from "./RightItem.vue?vue&type=style&index=0&id=02684ded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02684ded",
  null
  
)

export default component.exports